var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.4375C2.71094 4.4375 3.3125 5.03906 3.3125 5.75C3.3125 6.48828 2.71094 7.0625 2 7.0625C1.26172 7.0625 0.6875 6.48828 0.6875 5.75C0.6875 5.03906 1.26172 4.4375 2 4.4375ZM0.6875 1.59375C0.6875 0.882812 1.26172 0.28125 2 0.28125C2.71094 0.28125 3.3125 0.882812 3.3125 1.59375C3.3125 2.33203 2.71094 2.90625 2 2.90625C1.26172 2.90625 0.6875 2.33203 0.6875 1.59375ZM0.6875 9.90625C0.6875 9.19531 1.26172 8.59375 2 8.59375C2.71094 8.59375 3.3125 9.19531 3.3125 9.90625C3.3125 10.6445 2.71094 11.2188 2 11.2188C1.26172 11.2188 0.6875 10.6445 0.6875 9.90625Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/moreIcon.28ee1c02be231aa1edd468ea91e5dd6c.svg";
export { ForwardRef as ReactComponent };